<script setup>
import { computed,ref } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo-ct-dark.png";
import logoWhite from "@/assets/img/logo-ct.png";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);

const siteName = computed(() => process.env.VUE_APP_SITENAME);
//---------shops ---------
const shops = computed(() => store.getters.shops);
const selectedShopStore = computed(() =>store.getters.selectedShop);
const selectedShopId = ref(selectedShopStore.value?.Id);

import { shopService } from "@/services/shopService";

import { useRouter } from "vue-router";

const router = useRouter();

async function changeShop() {
  try {

    const response = await shopService.setCurrentShop(selectedShopId.value);

    if (!response.data?.Success) {
      throw new Error(response.data?.Message ?? "Nie udało się zmienić sklepu.");
    }

    console.log("Wybrano sklep:", selectedShopId.value);

    router.go(0);

  } catch (error) {

    console.error(error);
  }
}
//---------shops ---------
</script>
<template>
  <div
    v-show="layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-transparent' : 'bg-success'}`"
  />

  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="`${isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'}    
      ${
        layout === 'landing' ? 'bg-transparent shadow-none' : ' '
      } ${sidebarType}`"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>

      
      <router-link class="m-0 navbar-brand" to="/">
        <img
          :src="darkMode || sidebarType === 'bg-default' ? logoWhite : logo"
          class="navbar-brand-img h-100"
          alt="main_logo"
        />

        <span class="ms-2 font-weight-bold me-2">{{siteName}}</span>
      </router-link>
    </div>
    <select class="mx-4"
            v-model="selectedShopId"
            @change="changeShop">

            <option
                v-for="shop in shops" :key="shop.Id" :value="shop.Id">

                {{ shop.Name }}

            </option>

    </select>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list />
  </aside>
</template>
